import { render } from "./DrivenHeader.vue?vue&type=template&id=6c60b472&scoped=true"
import script from "./DrivenHeader.vue?vue&type=script&lang=js"
export * from "./DrivenHeader.vue?vue&type=script&lang=js"

import "./DrivenHeader.vue?vue&type=style&index=0&id=6c60b472&scoped=true&lang=css"

import exportComponent from "/usr/home/demon/projects/driven/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c60b472"]])

export default __exports__